/*
*  Init Object:
 -------------
 This is where all DSV javascript methods is initiated.
*
* */

(function($, window) {
  // When Document is ready
  // Initialize scripts;
  $(function() {
    
    // Overlay scripts should NOT run inside experience editor. So 
    if (!DSV.DOM.body.hasClass("experience-editor")) {
		
		// ALL content elements shown within overlay are done based on extracted parameters
		let overlayParams = {};
		let countryCodeParam;
		let queryString;
				
		// Add utm to params if added in url param
		let utmSourceParam = DSV.tools.getUrlParams("utm_source");
		if (utmSourceParam) {
			overlayParams["utm_source"] = utmSourceParam;
		}
		
		// Layer triggered currently only on frontpage of en website
		let triggerCountrySiteSuggest = (window.location.pathname == '/' || window.location.pathname == '/en/' || window.location.pathname == '/en');
		
		window.console.log("pathname: " + window.location.pathname);
		// Looking in cookie for earlier lookup of country code for user
		let countryCodeCookie = DSV.ui.cookies.getCookie("countryCode");
		
		// No countryCodeCookie found, so expect new user. 
		// Fetching users countrycode via ip lookup service
		if (triggerCountrySiteSuggest && !countryCodeCookie) {
			
			window.console.log("Cookie not found. Fetching country from service.");
			
			const countryCodePromise = fetch(
				`${DSV.data.iplookup.url}?access_key=${DSV.data.iplookup.accessKey}&fields=country_code`
			);
			countryCodePromise
				.then((response) => {
				return response.json();
			})
			.then((json) => {
				
				// Only set country code if possible to extract country code from service
				if (json.country_code) {
					
					window.console.log("Country code found: " + json.country_code);
					
					// Only set country code if extracted country code differs from current page country code
					//let cultureCode = document.documentElement.lang.slice(-2);
					
					//if (json.country_code !== cultureCode) {
						
						//window.console.log("Not same lang. Depricated check now?");
						
						countryCodeParam = json.country_code;
						
						// AGJ: TODO: This does not seem to be used in overlay at all?
						//DSV.data.iplookup.countryCode = countryCodeParam;

						// Set country_code in overlayParams
						overlayParams["country_code"] = countryCodeParam;
						
						window.console.log("overlayParams: " + overlayParams["country_code"]);
					  
						// Country site suggest overlay can be forced by adding &country_code=?? in query
						// Overwrite country_code to the one set as param instead of the one in cookie or looked up
						// Show layer no matter the url. For testing purposes of overlay.
						countryCodeParam = DSV.tools.getUrlParams("country_code");
						if (countryCodeParam) {
							overlayParams["country_code"] = countryCodeParam;
							window.console.log("country_code hardcoded to: " + overlayParams["country_code"]);
						}
						
						// set countrycode in cookie for future extraction/hiding if already set. 
						// NB: User could actually move location. Not relevant I expect?
						DSV.ui.cookies.setCookie("countryCode", countryCodeParam, 180);
						
						queryString = Object.keys(overlayParams).map((key) => key + "=" + overlayParams[key]).join("&");
						
						window.console.log("Final querystring for layer set to: " + queryString);
								
						// Check for overlayEndpoint before trying to load content into it
						if (DSV.data.overlayEndpoint) {
							// Only load overlay with content matching found parameters
							DSV.ui.overlays.loadContent(`${DSV.data.overlayEndpoint}?${queryString}`);
						}
						
					//}
				}
			  })
			  .catch((error) => {
				window.console.error(error);
			  });
			  			
		}
		// Check for utm source
		else if(utmSourceParam) {
			queryString = Object.keys(overlayParams).map((key) => key + "=" + overlayParams[key]).join("&");
			
			window.console.log("UTM Only querystring: " + queryString);
									
			// Check for overlayEndpoint before trying to load content into it
			if (DSV.data.overlayEndpoint) {
				// Only load overlay with content matching found parameters
				DSV.ui.overlays.loadContent(`${DSV.data.overlayEndpoint}?${queryString}`);
			}
		}
		else {
			window.console.log("CountryCode cookie already set to or trigger set to false. No UTM params added. Overlay not triggered.");
		}
		
	}

    // Add empty onclick method to labels with a 'for' attribute, to ensure click functionality on iPad (and other touch devices)
    if (Modernizr.touch) {
      $("label[for]", DSV.DOM.body).click(function() {});
    }
    // Setup Tweenlite default easing
    TweenLite.defaultEase = Power3.easeOut;

    DSV.ui.scroll.init();

    // Tooltips on Self Service Links
    var $selfService = DSV.DOM.body.find(
      ".self-service-box .self-service__link-list"
    );
    if ($selfService.length) {
      DSV.selfService.tooltip($selfService);
    }

    // Overlay triggers
    if (DSV.DOM.overlayTriggers.length) {
      for (var i = 0; i < DSV.DOM.overlayTriggers.length; i++) {
        DSV.ui.overlays.setupOverlayTriggers(DSV.DOM.overlayTriggers.eq(i)[0]);
      }
    }

    // Fix for tablet search-field
    if (DSV.tools.screenMode.currentMode === DSV.tools.screenSizes.desktop) {
      var $search = $("#search"),
        $searchInput = $search.find("input[type=search]"),
        $searchSubmit = $search.find("input[type=submit]");

      $searchSubmit.on("click", function(e) {
        if ($searchInput.val() === "") {
          e.preventDefault();
          e.stopPropagation();
          $searchInput.focus();
        }
      });
      $searchInput.on("blur", function(e) {
        if ($searchInput.val() === "") {
          $searchInput.removeClass("open");
        } else {
          $searchInput.addClass("open");
        }
      });
    }

    if (DSV.DOM.officesTable.length) {
      DSV.ui.offices.init();
    }
    if (DSV.DOM.accordions.length) {
      DSV.ui.accordionHandler.init(DSV.DOM.accordions);
    }

    if (DSV.DOM.siteSelector.length) {
      DSV.ui.siteSelector.init();
    }

    if (DSV.DOM.calculatorBox.length) {
      DSV.ui.calculatorBox.init();
    }

    if (DSV.DOM.responsiveTables.length) {
      DSV.ui.responsiveTables.init();
    }

    if (DSV.DOM.spotContents) {
      DSV.DOM.spotContents.forEach((spotContent) => {
        DSV.ui.spotContent.init(spotContent);
      });
    }

    if (DSV.DOM.lazyLoad.length || DSV.DOM.lazyLoadImmediately.length) {
      DSV.ui.lazyLoad.init();
    }

    if (DSV.DOM.mainNavigation.length) {
      DSV.ui.mainNavigation.init();
    }

    if (DSV.DOM.header.length) {
      DSV.ui.header.init();
    }

    if (DSV.DOM.headerWidget.length) {
      DSV.ui.headerWidget.init(DSV.DOM.headerWidget);
    }

    if (DSV.DOM.serviceTabs.length) {
      DSV.ui.serviceTabs.init();
    }

    if (DSV.DOM.subnavigationBar.length) {
      DSV.ui.subnavigationBar.init(DSV.DOM.subnavigationBar);
    }

    if (
      DSV.DOM.searchResult.length &&
      !DSV.DOM.body.hasClass("experience-editor")
    ) {
      DSV.ui.searchResult.init();
    }

    if (DSV.DOM.officeMap.length) {
      DSV.ui.maps.init();
    }

    if (DSV.DOM.officesList.length) {
      DSV.ui.offices.init(DSV.DOM.officesList);
    }

    if (DSV.DOM.newslist.length) {
      DSV.ui.newslist.init(DSV.DOM.newslist);
    }

	if (DSV.DOM.bannerNotification) {
      DSV.ui.bannerNotification.init(DSV.DOM.bannerNotification);
    }
	
    // Stock Quotes
    if (!document.getElementById("storybook-env")) {
      // Only load on main site
      var observer = new IntersectionObserver(
        function(entries) {
          // isIntersecting is true when element and viewport are overlapping
          // isIntersecting is false when element and viewport don't overlap
          if (entries[0].isIntersecting === true) {
            DSV.ui.stockQuotes.get();
            observer.unobserve(document.querySelector("footer.footer"));
          }
        },
        { threshold: [0] }
      );

      observer.observe(document.querySelector("footer.footer"));
    }
  });

  // Scripts on hold til content is loaded
  // Since they manipulate dom and renderblock
  DSV.DOM.window.on("load", function() {
    //#SMOOTHSCROLL IS DEACTIVATED BY REQUEST FROM DSV IN SPRINT-5
    //DSV.ui.anchor.init(); //handles smooth-scroll to anchors
    const isChrome =
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    if (window.location.hash) {
      const headerHeight = document.querySelector(".header").offsetHeight;
      if (isChrome) {
        setTimeout(function() {
          const hash = window.location.hash;
          window.location.hash = "";
          window.location.hash = hash;
          const offsetY = Math.round(window.scrollY);
          const scrollTargetY = offsetY - headerHeight;
          window.scrollTo(0, scrollTargetY);
        }, 300);
      } else {
        const elementId = window.location.hash.substring(1);
        const target = document.getElementById(elementId);
        const windowY = window.scrollY;
        const offsetY = Math.round(
          target.getBoundingClientRect().top + windowY
        );
        const scrollTargetY = offsetY - headerHeight;
        window.scrollTo(0, scrollTargetY);
      }
    }

    DSV.ui.autoComplete.init();
    //ToDo: Check if this renderblocking code is still needed
    // Add tiny delay to extrenal links, so GA tracking can be applied to them via an event
    $("a[href]", DSV.DOM.body).externalLink();

    if (DSV.DOM.formsDynamics.length) {
      DSV.ui.formsDynamics.init(DSV.DOM.formsDynamics);
    }
  });
})(jQuery, window);
